import { combineReducers } from 'redux';
import metadata from './metadata';
import states from './states';
import load from './load';
import editor from './editor';

export default combineReducers({ metadata, states, load, editor });
